export const shouldShowPopup = (node_uuid) => {
  if (!node_uuid) return false
  const isPlayed = parseInt(localStorage.getItem(`isPlayed-${node_uuid}`))
  console.log('isPlayed ', isPlayed)
  if (isPlayed) return false

  const isShowPopupInThisSession = parseInt(
    sessionStorage.getItem(`minigameInSession-${node_uuid}`)
  )
  if (isShowPopupInThisSession) return false
  const count = parseInt(localStorage.getItem(`minigame-${node_uuid}`))
  return !count || count < 4 ? true : false
}

export const countViewTime = (url) => {
  // /products/chan-vay-tweed-dang-
  // let test = '/products/chan-vay-tweed-dang'
  const getProductUrl = url.split('/')
  var getProductsView = sessionStorage.getItem(`productsView`)
  if (!getProductsView) {
    getProductUrl[2] != undefined && sessionStorage.setItem(`productsView`, getProductUrl[2])
  } else {
    var stringPr = getProductsView + ',' + (getProductUrl[2] != undefined && getProductUrl[2])
    sessionStorage.setItem(`productsView`, stringPr)
  }

  if (getProductUrl[1] === 'products') {
    var count = parseInt(sessionStorage.getItem(`countViewProductsPage`))
    !count ? (count = 1) : (count = count + 1)

    sessionStorage.setItem(`countViewProductsPage`, count)
  }
}
